export default function WhatWeAreNot() {
  const items = [
    'A passport vendor.',
    'A program shop.',
    'A lifestyle brand.',
    'A tax optimization service.',
    'A law firm.',
  ];

  return (
    <section
      id="what-we-are-not"
      data-testid="what-we-are-not-section"
      className="relative py-20 md:py-28 bg-[#efeee9]"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <div className="text-center mb-14">
          <h2
            className="text-4xl md:text-5xl font-semibold tracking-tight text-[#1a1a1a]"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            What We Are Not
          </h2>
        </div>

        <ul className="max-w-xl mx-auto space-y-4">
          {items.map((item, i) => (
            <li
              key={i}
              data-testid={`not-item-${i}`}
              className="text-gray-500 text-base leading-relaxed border-b border-gray-200/80 pb-4 last:border-0"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              {item}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
